import { Mandate } from "@/api/openapi";
import { Text } from "@fluentui/react-components";

import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons";
import { faCheckCircle as faCheckCircleFilled } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type MandatesMobileListItemProps = {
  isSelected: boolean;
  mandate: Mandate;
  onSelect: () => void;
};

export function MandatesMobileListItem({
  isSelected,
  mandate,
  onSelect,
}: MandatesMobileListItemProps) {
  return (
    <div className="flex flex-col gap-4 p-2">
      <div
        className="flex flex-row justify-between items-center px-6"
        onClick={() => onSelect()}
      >
        <div className="flex flex-col">
          <Text weight="semibold" size={400}>
            {mandate.name}
          </Text>
          <Text size={300} className="text-font-secondary">
            {mandate.taxNumber.toUpperCase()}
          </Text>
        </div>
        <div>
          <FontAwesomeIcon
            icon={isSelected ? faCheckCircleFilled : faCheckCircle}
            size="xl"
            className={isSelected ? "text-primary" : "text-font-secondary"}
          />
        </div>
      </div>
    </div>
  );
}
